import app from 'flarum/forum/app';
import Search from 'flarum/forum/components/Search';
import ItemList from 'flarum/common/utils/ItemList';
import DiscussionSearchSource from './DiscussionSearchSource';
import extractText from 'flarum/common/utils/extractText';
import classList from 'flarum/common/utils/classList';
import Input from 'flarum/common/components/Input';
export default class DiscussionSearch extends Search {
  view() {
    const currentSearch = this.searchState.getInitialSearch();

    // Initialize search sources in the view rather than the constructor so
    // that we have access to app.forum.
    if (!this.sources) this.sources = this.sourceItems().toArray();

    // Hide the search view if no sources were loaded
    if (!this.sources.length) return m("div", null);
    const searchLabel = extractText(app.translator.trans('core.forum.header.search_placeholder'));
    const isActive = !!currentSearch;
    const shouldShowResults = !!(this.searchState.getValue() && this.hasFocus);
    const shouldShowClearButton = !!(!this.loadingSources && this.searchState.getValue());
    return m("div", {
      role: "search",
      "aria-label": app.translator.trans('core.forum.header.search_role_label'),
      className: classList('Search', 'UiKit-Search', {
        open: this.searchState.getValue() && this.hasFocus,
        focused: this.hasFocus,
        active: isActive,
        loading: !!this.loadingSources
      })
    }, m(Input, {
      "aria-label": searchLabel,
      className: "Search-input",
      type: "search",
      placeholder: searchLabel,
      value: this.searchState.getValue(),
      onchange: value => this.searchState.setValue(value),
      clearable: shouldShowClearButton,
      loading: this.loadingSources,
      inputAttrs: {
        onfocus: () => this.hasFocus = true,
        onblur: () => this.hasFocus = false
      }
    }), m("ul", {
      className: "Dropdown-menu Search-results",
      "aria-hidden": !shouldShowResults || undefined,
      "aria-live": shouldShowResults ? 'polite' : undefined
    }, shouldShowResults && this.sources.map(source => source.view(this.searchState.getValue()))));
  }
  sourceItems() {
    const items = new ItemList();
    items.add('discussions', new DiscussionSearchSource(discussion => {
      this.searchState.setValue(discussion.title());
      this.attrs.onSelect(discussion);
    }, this.attrs.ignore));
    return items;
  }
}
flarum.reg.add('sycho-uikit', 'forum/components/DiscussionSearch', DiscussionSearch);